import { useCallback } from "react";
import { useApi } from "../api";
import type { DeckReportData } from "./types/report";

const getDeckDesignerReportUrl = (calculationId: string): string => `/modules/deck_designer/${calculationId}/report`;

/**
 * Renders the PDF report of a Deck Designer calculation on the server, in data.language, and downloads
 * it. Only for users who can read the calculation, or admins.
 */
export const useDeckDesignerReportApi = () => {
  const api = useApi();

  const downloadDeckDesignerReport = useCallback(
    (calculationId: string, data: DeckReportData, fileName: string): Promise<void> =>
      api.postForFileDownload(getDeckDesignerReportUrl(calculationId), data, fileName),
    [api],
  );

  return { downloadDeckDesignerReport };
};
